import { Badge } from "../ui/badge";
import { useLanguage } from "../../contexts/LanguageContext";

/** 結算單狀態 badge（Phase 7）— tone 樣式與 OrderStatusBadge 同一套（light/dark 雙模式）。 */
export type SettlementStatus = "draft" | "issued" | "paid" | "disputed";

const TONE_CLASS = {
  sky: "border-sky-600/30 bg-sky-100 text-sky-900 dark:border-sky-400/30 dark:bg-sky-400/15 dark:text-sky-200",
  emerald:
    "border-emerald-600/30 bg-emerald-100 text-emerald-900 dark:border-emerald-400/30 dark:bg-emerald-400/15 dark:text-emerald-200",
  stone: "border-stone-500/30 bg-stone-200/80 text-stone-700 dark:border-stone-400/30 dark:bg-stone-400/15 dark:text-stone-300",
  rose: "border-rose-600/30 bg-rose-100 text-rose-900 dark:border-rose-400/30 dark:bg-rose-400/15 dark:text-rose-200",
} as const;

const CONFIG: Record<SettlementStatus, {
  label: { "zh-TW": string; "en-US": string; "zh-CN": string };
  tone: keyof typeof TONE_CLASS;
}> = {
  draft: { label: { "zh-TW": "草稿", "en-US": "Draft", "zh-CN": "草稿" }, tone: "stone" },
  issued: { label: { "zh-TW": "已開立", "en-US": "Issued", "zh-CN": "已开立" }, tone: "sky" },
  paid: { label: { "zh-TW": "已付款", "en-US": "Paid", "zh-CN": "已付款" }, tone: "emerald" },
  disputed: { label: { "zh-TW": "爭議中", "en-US": "Disputed", "zh-CN": "争议中" }, tone: "rose" },
};

export function SettlementStatusBadge({ status, size = "sm" }: { status: SettlementStatus; size?: "default" | "sm" }) {
  const { t } = useLanguage();
  const cfg = CONFIG[status];
  return (
    <Badge variant="outline" size={size} className={TONE_CLASS[cfg.tone]}>
      {t(cfg.label)}
    </Badge>
  );
}
